/**
 * 
 */

export const getGeneralFaculty = (state) => state.generalFaculty;
